import { navigate } from '@reach/router'
import { Auth0Provider, AppState } from '@auth0/auth0-react'
import { getCurrentEnvConfig, getCurrentEnv } from '../../../config'
import { usePathPrefix } from '../../hooks/usePathPrefix'

const auth0Config = getCurrentEnvConfig().auth0

export const onRedirectCallback = (appState?: AppState) => {
  if (appState?.returnTo) {
    window.location.href = appState?.returnTo
  } else navigate('/', { replace: true })
}

const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const pathPrefix = usePathPrefix()

  const getRedirectURI = () => {
    if (typeof window === 'undefined') return ''

    if (getCurrentEnv() === 'LOCAL') {
      return `${window.location.origin}${pathPrefix}`
    }

    const isPreviewPath = pathPrefix.startsWith('/pull_request_previews/')
    const callbackBase = isPreviewPath
      ? window.location.origin
      : `${window.location.origin}${pathPrefix}`

    // Use a stable callback URL for preview builds so Auth0 doesn't need
    // every PR preview path to be whitelisted.
    return `${callbackBase}/redirect/`
  }

  return auth0Config.enabled ? (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        audience: auth0Config.audience,
        redirect_uri: getRedirectURI(),
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback
    >
      {children}
    </Auth0Provider>
  ) : (
    children
  )
}

export default AuthProvider
